import hawaree from "../assets/images/hawaree.png";
import webzen from "../assets/images/webzen.png";
import hawareeT from "../assets/images/hawareeT.png";
import webzenT from "../assets/images/webzenT.png";
import chris from '../assets/images/chris.png'
import sinaAlimi from '../assets/images/sinaAlimi.png'
import ericOkoruwa from '../assets/images/ericOkoruwa.png'
import kenneth from '../assets/images/kenneth.png'
import mission from '../assets/images/mission.png'
import vision from '../assets/images/vision.png'
import tagline from '../assets/images/tagline.png'
import core from '../assets/images/core.png'


export const landingCards = [
  {
    img: hawaree,
    heading: "Hawaree",
    text: "Hawaree Africa is our e-commerce and consumer goods distribution arm. We work with several international and domestic companies across a variety of consumer categories.",
    background: "#FC6702",
    url: 'https://hawaree.com',
    overlay: hawareeT,
    overlayBg: 'rgba(252, 103, 2, 0.50)'
  },
  {
    img: webzen,
    heading: "Webzen",
    text: "This is the agro-allied business arm of Kaxal Africa which is focused on providing investment and business support services to organizations in the agribusiness space. ",
    background: "#9ACB34",
    url: 'https://webzenagroallied.com',
    overlay: webzenT,
    overlayBg: 'rgba(154, 203, 52, 0.50)'
  },
];

export const teamData = [
  {
    img: chris,
    name: 'Chris Oshiafi',
    role: 'Chairman',
    text: ['Chris Oshiafi is the Group Chief Executive Officer of PanAfrican Capital Holdings with experience that spans over two decades in Structured Finance, Consulting, Investment Banking and Venture Capital/Private Equity.', ' He was the Pioneer Managing Director/CEO of Truebond Investments & Capital Limited, a Company with diverse interests in Oil & Gas, Telecommunications, Power and the Capital Markets. He has also worked with the firm of Damitop Consulting Limited as Managing Partner where he worked on a number of World Bank projects for the Federal and several State Governments. He served as Executive Director (Investment Banking) of Citizens International Bank (now Enterprise Bank Limited) until his appointment as the pioneer Chief Executive Officer of PanAfrican Capital Holdings Limited.', ' Chris holds a Bachelor of Science degree in Accounting & Finance from the University of London and Master’s degree in Business Administration degree from the University of Lagos. Chris is a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN), an Associate of the Chartered Insurance Institute of London, (ACII) UK and Chartered Institute of Taxation of Nigeria (ACIT). He also attended various programs at the prestigious Columbia Business School, New York, United States and INSEAD Business School, Fontainebleau, France, the IESE Business School in Barcelona, Spain and the Chief Executive Programme (CEP 17) Class of the Lagos Business School.'],
  },
  {
    img: sinaAlimi,
    name: 'Sina Alimi',
    role: 'Director',
    text: [' Sina is the Deputy Chief Executive Officer of PanAfrican Capital Holdings, a Proprietary Investment Company with presence in Lagos, Accra, Nairobi and Mauritius. ', 'He also serves is a member of the Board of Directors for several companies within the Group. Acquiring a Chartered Accountant status in 1991 charted a course for his entire career that spans over twenty-five (25) years cutting across Deal Structuring, Project Finance, Mergers & Acquisitions, Privatization and Asset Management.', 'Having worked with Diamond Bank Limited where he started his banking career in Audit and Banking Operations, Sina later joined the Investment Banking Division of Fountain Trust Bank Plc in 1997 and subsequently served as Group Head, Corporate Finance and Head, Investment Banking Group. While in Corporate Finance, Sina was actively involved in high profile projects and advisory mandates in the private sector as well as the privatization programme of the Federal Government of Nigeria.', ' The alumnus of Lagos Business School (LBS) and IESE Business School Barcelona, Spain is a graduate of Accounting from the prestigious University of Lagos, where he graduated as one of the best in his class. Sina is a Fellow of the Institute of Chartered Accountants of Nigeria (ICAN) and Chartered Institute of Taxation of Nigeria (CITN). He is also an alumnus of Lagos Business School (LBS) and IESE Business School Barcelona, Spain.']
  },
  {
    img: ericOkoruwa,
    role: 'Director',
    name: 'Eric Okoruwa',
    text: ['Eric Okoruwa is the Group Executive Director of PanAfrican Capital Holdings with over 20 years’ experience in investment banking and financial advisory.', ' Eric has been involved in various high-profile transactions, raising over $5 billion and N300 billion from both foreign and local financial institution and capital markets across diverse sector. While at Fountain Trust bank Plc, he worked on a number of high-profile private sector advisory transactions as well as the Federal Government privatization program of the Federal Government of Nigeria.', ' He holds a Bachelor of Science Degree in Business Administration from the University of Lagos and a Master’s degree in Marketing from the University of Lagos. He has attended a number of Executive courses, Advanced Manager’s Programme (AMP) from the Lagos Business School, “Leading Organizational Change” - Wharton University of Pennsylvania and the Lagos Business School Global Chief Executive Officer (GCEO) programme for Africa in conjunction with Strathmore University Business School and IESE Business School Navarra, New York.', ' He also attended various international and local courses on company Valuation and Issues Pricing, Factoring, Mergers & Acquisitions, Bonds & Derivatives, Asset Backed Securities, Structured Finance and International Trade Finance.']
  },
  // {
  //   img: kenneth,
  //   role: 'General Manager',
  //   name: 'KENNETH OSANEBI',
  //   text: [' Kenneth Osanebi is the General Manager of Kaxal Africa Limited (a member of PanAfrican Capital Holdings group). He is an agribusiness expert and a seasoned risk manager with over 20 years of experience in the banking and finance industry. Kenneth started his banking career with Citizens International Bank Limited in 2002. He has been extensively involved in the agriculture sector over the last ten years, working in various capacities, some of which include: Head, Agric Desk (Enterprise Bank Limited); Head, Project Monitoring and Remediation Office (NIRSAL – a corporation of Central Bank of Nigeria); Chief Operating Officer, (SmartAg Solutions Limited and AgLane Nigeria Limited) and Head, Agribusiness, Natural Resources and Project Development (Heritage Bank Plc). He has been involved in the provision of monitoring and evaluation services for agricultural projects covering over 150,000 hectares across various agriculture value chains in Nigeria. He led the team that provided aggregation services across fourteen Northern states in the 2021/2022 dry season wheat cultivation covering over 70,000 hectares. He holds a Bachelors degree in Mechanical Engineering. He is a Fellow of the following institutes: Chartered Institute of Export and Commodity Brokers of Nigeria (CIECOBON), Institute of Professional Managers & Administrators of Nigeria (IPMA), and Institute of Chartered Economists of Nigeria (ICEN). He is a full member of the Renewable Energy Institute (REI), United Kingdom, and the American Society of Agricultural Consultants (ASAC).']
  // },
]


export const values = [
  // {
  //   heading: 'Our Vision',
  //   text: 'To make sustainable investments, across the African continent, in the agribusiness and consumer goods distribution sectors.',
  //   img: vision
  // },
  // {
  //   heading: 'Our Mission',
  //   text: 'Leveraging market knowledge and technology to drive value for our stakeholders.',
  //   img: mission
  // },
  {
    heading: 'Tagline',
    text: '“… beyond limits”',
    img: tagline
  },
  {
    heading: 'Core Values',
    text: 'S P I R I T',
    img: core,
    items: ['S	- Service with Passion', 'P	- Professionalism', 'I	- Integrity', 'R	- Respect for Individual', 'I	- Innovation', 'T	- Team Spirit']
  },
]

export const paths = [
  {
    text: 'home',
    path: '/'
  },
  {
    text: 'about',
    path: '/about'
  },
  {
    text: 'services',
    path: '/services'
  },
  // {
  //   text: 'news',
  //   path: '/news'
  // },
  {
    text: 'contact',
    path: '/contact'
  },
]